import { getConfigValue } from "./getConfigValue";

// marketProductMap shape: [{ marketID: 1, productID: [309, 310] }, ...]

export function isMarketProductMappingEnabled(appState) {
    const enabled = getConfigValue(appState?.config?.MarketProductMapping?.Enabled, appState)?.Value;
    return String(enabled).toLowerCase() === 'true'
        && Array.isArray(appState?.marketProductMap)
        && appState.marketProductMap.length > 0;
}

function toNumber(value) {
    return Number.parseInt(value, 10);
}

export function getMarketIdsForProduct(marketProductMap, clientProductId) {
    if (!Array.isArray(marketProductMap)) {
        return [];
    }
    const productId = toNumber(clientProductId);
    return marketProductMap
        .filter(m => {
            const productIds = m?.productID || m?.productId || m?.productIds;
            return Array.isArray(productIds) && productIds.some(p => toNumber(p) === productId);
        })
        .map(m => toNumber(m?.marketID ?? m?.marketId));
}

export function getProductIdsForMarket(marketProductMap, marketId) {
    if (!Array.isArray(marketProductMap)) {
        return [];
    }
    const id = toNumber(marketId);
    return marketProductMap
        .filter(m => toNumber(m?.marketID ?? m?.marketId) === id)
        .flatMap(m => {
            const productIds = m?.productID || m?.productId || m?.productIds;
            return Array.isArray(productIds) ? productIds.map(toNumber) : [];
        });
}

export function isProductInMarket(marketProductMap, marketId, clientProductId) {
    return getProductIdsForMarket(marketProductMap, marketId).includes(toNumber(clientProductId));
}

// products that are not mapped to any market are not usable once mapping is enforced
export function filterProductsByMarketMapping(appState, products) {
    if (!isMarketProductMappingEnabled(appState)) {
        return products || [];
    }
    return (products || []).filter(p => getMarketIdsForProduct(appState.marketProductMap, p.clientProductId).length > 0);
}

export function filterMarketsForProduct(appState, markets, clientProductId) {
    if (clientProductId === null || clientProductId === undefined || !isMarketProductMappingEnabled(appState)) {
        return markets || [];
    }
    const allowedMarketIds = getMarketIdsForProduct(appState.marketProductMap, clientProductId);
    return (markets || []).filter(m => allowedMarketIds.includes(toNumber(m.id)));
}
